export const containerStyles =
   'flex flex-col justify-between flex-1 min-h-0 w-full overflow-x-hidden relative pb-[20px]'
